export default __webpack_public_path__ + "static/media/noOnboarding.b9edd54a.gif";